import { useFormikContext } from 'formik';
import { Flex } from 'yoso';
import { useIsMobile } from '~/components/Breakpoint/Breakpoint.hook';
import { EvolveFormButton } from '~/components/Evolve/Button/EvolveFormButton';
import { EvolveValues } from '~/components/Evolve/Form/EvolveForm.hooks';
import { HeaderSticky } from '~/components/Header';
import { ArrowRight } from '~/components/Icon/ArrowRight';
import { useEvolution } from '../../Evolve.hooks';
import styles from './EvolveSticky.module.scss';

export const EvolveSticky = () => {
  const isMobile = useIsMobile();
  const {
    values: { tokenType = '' },
    submitForm,
  } = useFormikContext<EvolveValues>();
  const {
    data: { growth, evolvedGrowth },
  } = useEvolution(tokenType);
  return (
    <HeaderSticky className={styles.root} rootMargin={`${isMobile ? '0px' : '-132px'} 0px 0px 0px`}>
      <EvolveFormButton
        className={styles.button}
        color="primary"
        size="large"
        type="button"
        onClick={submitForm}>
        <Flex container justifyContent="center" alignItems="center">
          <p>{growth}</p>
          <ArrowRight className={styles.icon} />
          <p>{evolvedGrowth}</p>
        </Flex>
      </EvolveFormButton>
    </HeaderSticky>
  );
};
